import React from 'react';
import StepWorkArchiveTab from './StepWorkArchiveTab';
import styles from '../styles/profileModal.module.css';

interface StartOverModalProps {
  isOpen: boolean;
  onClose: () => void;
  user?: { email?: string };
}

const StartOverModal: React.FC<StartOverModalProps> = ({ isOpen, onClose, user }) => {
  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Save &amp; Start over</h2>
          <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
            ×
          </button>
        </div>
        <div className={styles.modalBody}>
          <StepWorkArchiveTab user={user} />
        </div>
      </div>
    </div>
  );
};

export default StartOverModal;
